import moment from 'moment';

export const toDateFormat = (time = moment(new Date())) => {
  // must be in milliseconds
  return new Date(time.seconds * 1000 + time.nanoseconds / 1000000);
};

export const weekDayName = time => {
  return time.toLocaleString('default', { weekday: 'long' });
};

export const monthName = time => {
  return time.toLocaleString('default', { month: 'short' });
};

export const calculateLastActive = (time = moment(new Date())) => {
  let currentDate = moment(new Date());
  let oldDate =
    time.seconds && time.nanoseconds
      ? toDateFormat(time)
      : moment(new Date(time));

  const yearsDiff = currentDate.diff(oldDate, 'years');
  if (yearsDiff > 0) return `${yearsDiff}y`;

  const monthsDiff = currentDate.diff(oldDate, 'months');
  if (monthsDiff > 0) return `${monthsDiff}m`;

  const daysDiff = currentDate.diff(oldDate, 'days');
  if (daysDiff > 0) return `${daysDiff}d`;

  const hoursDiff = currentDate.diff(oldDate, 'hours');
  if (hoursDiff > 0) return `${hoursDiff}h`;

  const minutesDiff = currentDate.diff(oldDate, 'minutes');
  if (minutesDiff > 0) return `${minutesDiff}m`;

  return 'few seconds';
};

export const messageDate = time => {
  const date = moment(time);
  const daysDiff = moment().diff(date, 'days', true);
  const yesterday = moment().subtract(1, 'day');

  return daysDiff > 7
    ? date.format('l')
    : daysDiff > 1
    ? date.format('dddd')
    : date.isSame(yesterday, 'day')
    ? 'Yesterday'
    : date.format('LT');
};

export const age = year => {
  const date = new Date();
  return date.getFullYear() - Number(year);
};

export const populateDate = (str, date) => {
  return str
    .replace('{date}', moment(toDateFormat(date)).format('l'))
    .replace('{time}', moment(toDateFormat(date)).format('LT'));
};
